import React from 'react';
import { Session } from '../types/pomodoro';
import { lastSevenDays, localDateKey } from '../utils/time';
export function WeekChart({
  sessions
}: {
  sessions: Session[];
}) {
  const days = lastSevenDays();
  const totals = days.map(day => ({
    ...day,
    minutes: sessions.filter(s => localDateKey(s.endedAt) === day.key).reduce((sum, s) => sum + s.minutes, 0)
  }));
  const max = Math.max(30, ...totals.map(d => d.minutes));
  return <ul className="flex h-32 items-end justify-between gap-2" aria-label="Focus minutes over the last seven days" data-id="element-79" data-mp="ii861qglyx05">
      {totals.map((day, index) => <li key={day.key} className="flex h-full flex-1 flex-col items-center justify-end gap-2" data-id="element-80" data-mp="9il6la7fw19q" data-mpi={index}>
          <span className="text-[10px] tabular text-muted" data-id="element-81" data-mp="4ji0rnjmxr0p">{day.minutes > 0 ? day.minutes : ''}</span>
          <div className={`w-full rounded-t-md transition-[height] duration-200 ease-calm ${index === totals.length - 1 ? 'bg-coral' : 'bg-line'}`} style={{
        height: `${Math.max(day.minutes > 0 ? 6 : 2, day.minutes / max * 100)}%`
      }} data-id="element-82" data-mp="2uawob9k39eeb" />
          <span className="text-[11px] text-muted" data-id="element-83" data-mp="4e36sc6lsgrb">{day.label}</span>
        </li>)}
    </ul>;
}